// extracted by mini-css-extract-plugin
module.exports = {"relatedArticles":"RelatedArticles_relatedArticles__Me40e"};